import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { BuocThucHien } from './buoc-thuc-hien';
@Injectable()
export class BuocThucHienService {

    controller:string = 'XL_BuocThucHien';
    constructor(private http: Http) { }
    
    GetList(idQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?idQuyTrinh=" + idQuyTrinh, { headers: headers }).map(resp => resp.json());       
    }
    GetListIds(idQuyTrinh:string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListIds?idQuyTrinh=" + idQuyTrinh, { headers: headers }).map(resp => resp.json());       
    }
    GetListBuocChiTiet(idQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListBuocChiTiet?idQuyTrinh=" + idQuyTrinh, { headers: headers }).map(resp => resp.json());       
    }
    GetListSelect(idQuyTrinh:number,idBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListSelect?idQuyTrinh=" + idQuyTrinh+"&idBuoc="+idBuoc, { headers: headers }).map(resp => resp.json());       
    }
    GetListCauHinh(idQuyTrinh:number,idBuoc:number,idCauHinh:number,idKetQua:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListCauHinh?idQuyTrinh=" + idQuyTrinh+"&idBuoc="+idBuoc+"&idCauHinh="+idCauHinh+"&idKetQua="+idKetQua, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:BuocThucHien) {
        let headers = new Headers();
        item.TrangThai = 1;
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Delete(item:BuocThucHien) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Delete', item, { headers: headers }).map(resp => resp.json());
    }
    CapNhatSTT(data:any) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        //return this.http.post(Config.apiUrl+ this.controller+ '/CapNhatSTT', JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
        return this.http.get(Config.apiUrl+ this.controller+ '/CapNhatSTT?dto=' + JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
    }
    GetListCauHinhNhom(idQuyTrinh:number,idBuoc:number,idCauHinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListCauHinhNhom?idQuyTrinh=" + idQuyTrinh+"&idBuoc="+idBuoc+"&idCauHinh="+idCauHinh, { headers: headers }).map(resp => resp.json());       
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/buoc-thuc-hien.service.ts